import React, { useEffect, useState } from "react";
import QuoteComponent from "./quote";
import { useLocation } from "react-router-dom";
const QuoteList = props => {
  const location = useLocation();
  // console.log(JSON.stringify(location.state?.policyData))
  const policyPreviousData = location.state?.policyData;

  return (
    <>
      {/* this will visible if policy is visble for employee (/*START: If Quote Type != new )*/}
      {location.state?.from == "policy" && (
        <>
          <h6 className="text-primary mt-6">Vehicle Details</h6>
          <div className="card mb-4">
            <div className="card-body">
              <div>
                <div className="row">
                  <div className="col-md-3">
                    <label className="cust-fs-12">Registration No.</label>
                    <p className="fw-bold cust-fs-12">
                      <b>{policyPreviousData?.vehicle_no ? policyPreviousData?.vehicle_no : "-"}</b>
                    </p>
                  </div>
                  <div className="col-md-3">
                    <label className="cust-fs-12">Vehicle Make & Model</label>
                    <p className="fw-bold cust-fs-12">
                      <b> {policyPreviousData?.vehicle_make && policyPreviousData?.vehicle_model ? `${policyPreviousData?.vehicle_make} - ${policyPreviousData?.vehicle_model}` : "-"} </b>
                    </p>
                  </div>
                  <div className="col-md-3">
                    <label className="cust-fs-12">Expiring Insurer</label>
                    <p className="fw-bold cust-fs-12">
                      <b> {policyPreviousData?.insurer_name ? policyPreviousData?.insurer_name : "-"}</b>
                    </p>
                  </div>
                  <div className="col-md-3">
                    <label className="cust-fs-12">Renewal Date</label>
                    <p className="fw-bold cust-fs-12">
                      <b>{policyPreviousData?.policy_expiry_date ? policyPreviousData?.policy_expiry_date : "-"}</b>
                    </p>
                  </div>

                  <div className="col-md-3">
                    <label className="cust-fs-12">Previous Addon</label>
                    <p className="fw-bold cust-fs-12">
                      <b> {policyPreviousData?.current_plan ? policyPreviousData?.current_plan : "-"} </b>
                    </p>
                  </div>
                  <div className="col-md-3">
                    <label className="cust-fs-12">Previous Premium</label>
                    <p className="fw-bold cust-fs-12">
                      <b>{policyPreviousData?.gross_premium ? policyPreviousData?.gross_premium : "-"}</b> 
                    </p>
                  </div>
                </div>
              </div>
              {/*END: If Quote Type != new  */}
            </div>
          </div>
        </>
      )}
      {/* END  */}

      <div className="px-4 pb-5">
        <div className="row mb-4">
          <QuoteComponent
            from={location.state?.from}
            policyPreviousData={policyPreviousData}
          />
        </div>
      </div>
    </>
  );
};

export default QuoteList;
